import {
  EMPLOYEE_CREATE_FAIL,
  EMPLOYEE_CREATE_REQUEST,
  EMPLOYEE_CREATE_RESET,
  EMPLOYEE_CREATE_SUCCESS,
  EMPLOYEE_DELETE_FAIL,
  EMPLOYEE_DELETE_REQUEST,
  EMPLOYEE_DELETE_SUCCESS,
  EMPLOYEE_DELETE_RESET,
  EMPLOYEE_DETAILS_FAIL,
  EMPLOYEE_DETAILS_REQUEST,
  EMPLOYEE_DETAILS_SUCCESS,
  EMPLOYEE_DETAILS_RESET,
  EMPLOYEE_LIST_FAIL,
  EMPLOYEE_LIST_REQUEST,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_UPDATE_REQUEST,
  EMPLOYEE_UPDATE_RESET,
  EMPLOYEE_UPDATE_SUCCESS,
  PRODUCT_CREATE_REVIEW_FAIL,
  PRODUCT_CREATE_REVIEW_REQUEST,
  PRODUCT_CREATE_REVIEW_RESET,
  PRODUCT_CREATE_REVIEW_SUCCESS,
  PRODUCT_PRODUCTS_TOP_FAIL,
  PRODUCT_PRODUCTS_TOP_REQUEST,
  PRODUCT_PRODUCTS_TOP_SUCCESS,
  EMPLOYEEALL_LIST_REQUEST,
  EMPLOYEEALL_LIST_SUCCESS,
  EMPLOYEEALL_LIST_FAIL,
  EMPLOYEE_DEACTIVATE_REQUEST,
  EMPLOYEE_DEACTIVATE_SUCCESS,
  EMPLOYEE_DEACTIVATE_FAIL,
  EMPLOYEE_DEACTIVATE_RESET,
  EMPLOYEE_BY_DEPARTMENT_LIST_REQUEST,
  EMPLOYEE_BY_DEPARTMENT_LIST_SUCCESS,
  EMPLOYEE_BY_DEPARTMENT_LIST_FAIL,
} from "../constants/employeeConstants";

export const employeeListReducer = (state = { employees: [] }, action) => {
  // console.log(action.payload);
  switch (action.type) {
    case EMPLOYEE_LIST_REQUEST:
      return { loading: true };
    case EMPLOYEE_LIST_SUCCESS:
      return {
        loading: false,
        employees: action.payload,
      };
    case EMPLOYEE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
export const employeeAllListReducer = (
  state = { employeesAll: [] },
  action
) => {
  // console.log(action.payload);
  switch (action.type) {
    case EMPLOYEEALL_LIST_REQUEST:
      return { loading: true };
    case EMPLOYEEALL_LIST_SUCCESS:
      return {
        loading: false,
        employeesAll: action.payload,
      };
    case EMPLOYEEALL_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const employeeDetailsReducer = (state = { employee: {} }, action) => {
  switch (action.type) {
    case EMPLOYEE_DETAILS_REQUEST:
      return { loading: true, ...state };
    case EMPLOYEE_DETAILS_SUCCESS:
      return { loading: false, employee: action.payload };
    case EMPLOYEE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DETAILS_RESET:
      return { employee: {} };

    default:
      return state;
  }
};

export const employeeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_CREATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_CREATE_SUCCESS:
      return { loading: false, success: true, employee: action.payload };
    case EMPLOYEE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_DELETE_REQUEST:
      return { loading: true };
    case EMPLOYEE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDeactivateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_DEACTIVATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_DEACTIVATE_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_DEACTIVATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DEACTIVATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_UPDATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeByDepartmentListReducer = (
  state = { employeesbyDepartment: [] },
  action
) => {
  // console.log(action.payload);
  switch (action.type) {
    case EMPLOYEE_BY_DEPARTMENT_LIST_REQUEST:
      return { loading: true };
    case EMPLOYEE_BY_DEPARTMENT_LIST_SUCCESS:
      return {
        loading: false,
        employeesbyDepartment: action.payload,
      };
    case EMPLOYEE_BY_DEPARTMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
